import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { getAzureUserInformation } from '@/auth/azure/azureManager'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import OfferCreatorRoute from '@/routes/offers/OfferCreator.route'
import OfferEditorRoute from '@/routes/offers/OfferEditor.route'
import OffersPage from '@/routes/offers/OffersPage'
import { RoleRoute, RoleRouteObject, RouteFunctionParams } from '@/types'
import { defer, LoaderFunction } from 'react-router-typesafe'
import { azienda } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { ODataModelResponseV4 } from '@odata2ts/odata-core'
import { HttpResponseModel } from '@odata2ts/http-client-api'
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons'

export const offersPageRouteLoader = (async ({ request, params }: RouteFunctionParams<'clientId'>) => {
  const qsAdminApi = useQsAdminApiManager.getState().service

  const clientId = params.clientId
  let azienda: HttpResponseModel<ODataModelResponseV4<azienda>> | undefined
  if (clientId)
    azienda = await qsAdminApi.azienda(Number(clientId)).query((builder, azienda) => {
      builder.select('id', 'nome')
    })

  const title = azienda ? `${azienda.data.nome} - Offerte` : 'Offerte'

  const getAziende = qsAdminApi.azienda().query((builder, azienda) => {
    builder.select('id', 'nome')
    builder.orderBy(azienda.nome.asc())
  })

  return defer({
    title,
    aziende: await getAziende,
    userInfo: await getAzureUserInformation(),
    defaultCRUDAllowedRoles: [
      Roles.GlobalAdministrator,
      Roles.Administrator,
      Roles.Supervisor,
      Roles.Sales,
      Roles.ExternalSales,
    ],
  })
}) satisfies LoaderFunction

export const OffersPageRoute: RoleRoute = {
  path: 'offers',
  children: [
    {
      index: true,
      element: <OffersPage />,
      loader: offersPageRouteLoader,
      allowedRoles: [
        Roles.Sales,
        Roles.ExternalSales,
        Roles.Administrator,
        Roles.GlobalAdministrator,
        Roles.Marketing,
        Roles.Supervisor,
      ],
    } as RoleRouteObject,
    OfferCreatorRoute,
    OfferEditorRoute,
  ],
  errorElement: <RouterErrorHandler />,
  text: 'Offerte',
  faIcon: faMoneyBill,
  mainMenuRoute: true,
  handle: {
    crumb: () => ({
      label: 'Offerte',
      icon: faMoneyBill,
    }),
  },
  allowedRoles: [
    Roles.Sales,
    Roles.ExternalSales,
    Roles.Administrator,
    Roles.GlobalAdministrator,
    Roles.Marketing,
    Roles.Supervisor,
  ],
}
